// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_27dkE","visuallyhidden":"_10lZL","hide-text":"_3kaLo","center":"_2iinN","noprint":"_5u5hC","wrapper":"SNyOb"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-feedback/styles/default.scss
 ** module id = 1000
 ** module chunks = 2
 **/